import React from "react";

const About = () =>{

    return(

    <div className="mb-20">
        <h1 className="sm:text-4xl text-2xl font-bold mt-6 text-gray-900">About</h1>
        <p className="mt-4">The Marvel Cinematic Universe (MCU) is an American media franchise and shared universe centered on a series of superhero films produced by Marvel Studios. The films are based on characters that appear in American comic books published by Marvel Comics. The franchise also includes television series, short films, digital series, and literature.</p>
        <br/>
        <p>The DC Universe (DCU) is the fictional shared universe where most stories in American comic book titles published by DC Comics take place. Superheroes such as Superman, Batman, Wonder Woman, Martian Manhunter, The Flash, Green Lantern, Aquaman, and Green Arrow are from this universe, as well as teams such as the Justice League and the Teen Titans.</p>

    </div>
    );
};

export default About;